import { onEditorClosed } from '../actions/publicActions';
import { resetAccountsEditorStore } from '../actions/internalActions';
import { orchestrator } from 'satcheljs';
import { AccountsEditorState } from '../store/schema/AccountsEditorState';
import getAccountsEditorState from '../selectors/getAccountsEditorState';
import {
    getEditorSessionAddedAccounts,
    getConnectAccountAttempted,
} from '../selectors/getCurrentSessionAccounts';
import { logUsage } from 'owa-analytics';
import { getOWAConnectedAccounts } from 'owa-accounts-store';
import { getCalendarEntries } from 'owa-calendar-cache';
import {
    AccountsFeedbackInitSource,
    lazyGetHasShownAddAccountFailureFeedbackDialog,
    showAddAccountFailureFeedbackDialog,
} from 'owa-accounts-feedback';
import getIsAccountRemovalErrorDialogReferral from '../selectors/getIsAccountRemovalErrorDialogReferral';

orchestrator(onEditorClosed, () => {
    const accountsEditorState = getAccountsEditorState();

    logAccountsEditorClosed(accountsEditorState);
    showFeedbackDialog(accountsEditorState);

    resetAccountsEditorStore();
});

function logAccountsEditorClosed(accountsEditorState: AccountsEditorState) {
    const { areCalendarsLoaded, connectedAccountProvider } = getConnectedAccountListDatapoints();
    const { isConnectedAccountAdding, accountRemovedOnErrorReferral } = getAccountStateDatapoints(
        accountsEditorState
    );

    if (
        areCalendarsLoaded ||
        connectedAccountProvider ||
        isConnectedAccountAdding ||
        accountRemovedOnErrorReferral
    ) {
        logUsage('accountsEditorClosed', {
            areCalendarsLoaded_1: areCalendarsLoaded,
            accountProvider_2: connectedAccountProvider,
            isConnectedAccountAdding_3: isConnectedAccountAdding,
            accountRemovedOnErrorReferral_4: accountRemovedOnErrorReferral,
        });
    }
}

function getConnectedAccountListDatapoints() {
    let areCalendarsLoaded = null;
    let connectedAccountProvider = null;

    getOWAConnectedAccounts()
        .filter(account => getEditorSessionAddedAccounts().includes(account.userIdentity))
        .forEach(account => {
            // This needs updated in the multi-multi-account world
            areCalendarsLoaded =
                getCalendarEntries().filter(
                    calendar =>
                        calendar?.calendarId.mailboxInfo.userIdentity == account.userIdentity
                )?.length > 0;

            connectedAccountProvider = account.accountProviderType;
        });

    return {
        areCalendarsLoaded: areCalendarsLoaded,
        connectedAccountProvider: connectedAccountProvider,
    };
}

function getAccountStateDatapoints(accountsEditorState: AccountsEditorState) {
    const isConnectedAccountAdding = getConnectAccountAttempted()
        ? accountsEditorState == AccountsEditorState.Adding
        : null;
    const accountRemovedOnErrorReferral = getIsAccountRemovalErrorDialogReferral();

    return {
        isConnectedAccountAdding: isConnectedAccountAdding,
        accountRemovedOnErrorReferral: accountRemovedOnErrorReferral,
    };
}

async function showFeedbackDialog(accountsEditorState: AccountsEditorState) {
    if (accountsEditorState == AccountsEditorState.Adding) {
        let getHasShownFeedbackDialog = await lazyGetHasShownAddAccountFailureFeedbackDialog.import();
        const hasShownFeedbackDialog = getHasShownFeedbackDialog();

        if (!hasShownFeedbackDialog) {
            showAddAccountFailureFeedbackDialog(
                AccountsFeedbackInitSource.UserCancelledOnEditorClosed
            );
        }
    }
}
